export default __webpack_public_path__ + "static/media/1.df20a559.png";